// Builds a venmo.com link that opens the Venmo app (via universal links on
// mobile) or the website otherwise. `charge` requests money from `recipient`;
// otherwise it pays them.
export function constructVenmoUrl(
  pay: boolean,
  amount: string,
  recipient?: string,
  note?: string
): string {
  const params = new URLSearchParams();
  params.set("txn", pay ? "pay" : "charge");
  params.set("amount", amount);
  if (recipient) params.set("recipients", recipient);
  if (note) params.set("note", note);
  return `https://venmo.com/?${params.toString()}`;
}
